/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_RotateInputs */

const en_mobile_scan_rotate = /** @type {(inputs: Mobile_Scan_RotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate`)
};

const es_mobile_scan_rotate = /** @type {(inputs: Mobile_Scan_RotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Girar`)
};

/**
* | output |
* | --- |
* | "Rotate" |
*
* @param {Mobile_Scan_RotateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_rotate = /** @type {((inputs?: Mobile_Scan_RotateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_RotateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_rotate(inputs)
	return en_mobile_scan_rotate(inputs)
});